import React from "react";

const QuizQuestion = ({ question, onAnswer }) => {
  const handleAnswerClick = (value) => {
    const isCorrect = value === question?.answer;
    onAnswer(isCorrect);
  };

  const renderOptions = () => {
    return [1, 2, 3, 4].map((i) => (
      <button
        key={i}
        onClick={() => handleAnswerClick(question[`option${i}`]?.value)}
        className="w-full border-2 sm:w-auto bg-white-500  text-black py-2 px-4 rounded-lg hover:bg-white-700 transition-colors"
      >
        {question?.type?.value === 2 ? (
          <img
            src={question[`option${i}`]?.label}
            alt={`Option ${i}`}
            className="w-full h-32 object-contain"
          />
        ) : (
          question[`option${i}`]?.label
        )}
      </button>
    ));
  };

  const getDetailQuestion = () => {
    if(question === null || question === undefined){
      return "";
    }

    let arr = question?.question.split("~");
    if(arr.length > 1){
      return arr[1];
    }
    else{
      return "";
    }
  }

  return (
    <div className="w-full  p-4 bg-white rounded-lg shadow-md">
      {question?.type?.value === 3 ? (
        <div className="flex flex-col space-y-2 mb-4">
          <img
            src={question?.question?.split("~")[0]}
            alt="Question"
            className="w-full h-60 object-contain mb-4"
          />
          <h2 className="text-xl font-semibold">{getDetailQuestion()}</h2>
        </div>
      ) : question?.type?.value === 4 ? (
        <audio controls className="w-full mb-4">
          <source src={question?.question} type="audio/mp3" />
        </audio>
      ) : (
        <h2 className="text-xl font-semibold mb-4">{question?.question}</h2>
      )}
      {question?.option1 && (
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-2">
          {renderOptions()}
        </div>
      )}
    </div>
  );
};

export default QuizQuestion;
